<template>
<!-- 封装echarts -->
  <div :style="setStyle">
    <div :id="chartID" :option="option" style="width:100%;height:100%;" />
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'eChart',
  data () {
    return {
      setStyle: `width: ${this.width}; height: ${this.height}`
    }
  },
  props: {
    chartID: {
      type: String,
      default: ''
    },
    option: {},
    width: {
      type: String,
      default: '750px'
    },
    height: {
      type: String,
      default: '400px'
    }
  },
  methods: {
    setChartData (option) {
      var eChart = echarts.init(document.getElementById(this.chartID), 'light')
      var vm = this
      eChart.getZr().on('click', function(param,v=vm) {
        // 获取 点击的 触发点像素坐标
        const pointInPixel = [param.offsetX, param.offsetY]
        // 判断给定的点是否在指定的坐标系或者系列上
        if (eChart.containPixel('grid', pointInPixel)) {
        	// 获取到点击的 x轴 下标  转换为逻辑坐标
          let xIndex = eChart.convertFromPixel({ seriesIndex: 0 },pointInPixel)[0]
          v.$emit('selectTime',xIndex)
        }
      })
      // 将可以响应点击事件的范围内，鼠标样式设为pointer--------------------
      eChart.getZr().on('mousemove', function(params) {
        var pointInPixel = [params.offsetX, params.offsetY]
        if (eChart.containPixel('grid', pointInPixel)) {
        	// 将此区域的 鼠标样式变为 小手
          eChart.getZr().setCursorStyle('pointer')
        }
      })
      eChart.on('click', function (param, v = vm) {
        // eslint-disable-next-line vue/custom-event-name-casing
        v.$emit('selectTime', param.dataIndex)
      })
      eChart.setOption(option)
    }
  },
  mounted () {
  },
  watch: {
    // option: function (val) {

    // }
  }
}
</script>

<style>
</style>
